module.exports = __webpack_public_path__ + "img/andrea.7bb7e9b8.jpeg";